<script>
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import OcupationalMedicineAPI from "@/services/standards/ocupationalMedicine/ocupationalMedicineAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import Pagination from "./OcupationalPagination";
/**
 * Basic Tables component
 */
export default {
  components: { Pagination },
  data() {
    return {
      title: "3.1.1 Evaluación médica ocupacional",
      userSelected: null,
      usersList: [],
      lista: [],
      file: null,
      listaII: null,
      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
      },

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso"
        },
        {
          id: 2,
          name: "Exámenes periódicos"
        },
        {
          id: 3,
          name: "examen de retiro"
        }
      ],

    };

  },
  methods: {
    fetch() {
      this.$refs.paginator.query();
    },
    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        const url = `${this.ocupationalMedicine.employee_id}/medicinaOcupacional/${this.ocupationalMedicine.exam_date}/${this.file.name}`;
        const result = await uploadDocument(url, this.file);
        console.log(result);
        if (result) {
          this.ocupationalMedicine.file = `${process.env.VUE_APP_BUCKET}/${url}`;
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      OcupationalMedicineAPI.getAllMedicineCompany(this.$route.params.id)
        .then((response) => {
          let medicine = response.Ocupational_medical.data;
          this.lista = medicine
          this.listaII = medicine.ocupational_medical[0]
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      OcupationalMedicineAPI.save(this.ocupationalMedicine)
        .then((response) => {
          if (response.message === 'ocupational_medical creado con exito') {
            Swal.fire({
              title: "Información registrada con éxito!",
              text: "Información registrada con éxito!",
              icon: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
            //  window.location.reload()
          }

        })
        .catch((error) => {
          console.log(error);
        });

    },

    getUsers() {
      CompanyAPI.getCompany(this.$route.params.id)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res
            })
        })
        .catch((error) => {
          console.log(error);
        });

    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    deleteMedicine(id) {
      OcupationalMedicineAPI.deleteMedicine(id)
        .then((data) => {
          Swal.fire({
            title: "Se ha sido eliminado con exito!",
            text: "Se ha sido eliminado con exito!",
            icon: "success",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },

  mounted() {
    this.getUsers();
    this.getList();
  },

};
</script>

<template>

  <div class="row">

    <div class="col-md-12">
      <div class="card">
        <div class="card-body col-12">
          <h4 class="col-3 header-title"> Modo de verificación <i class="mdi mdi-eye"></i></h4>

          <form class="form-group" @submit.prevent="save">
            <div class="form-row pt-3">

              <b-form-group id="example text" label-for="employee" class="col-md-6 px-2" label="Empleado">
                <select required class="form-control" v-model="ocupationalMedicine.employee_id">
                  <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                    {{ item.full_name }}
                  </b-form-select-option>
                </select>
              </b-form-group>

              <b-form-group class="col-md-6 px-2" label="Fecha examen" label-for="exam_date">
                <b-form-input type="date" id="exam_date" v-model="ocupationalMedicine.exam_date">
                </b-form-input>
              </b-form-group>

              <b-form-group id="example text" label-for="exam_cycles" class="col-md-6 px-2" label="Ciclo de examen">
                <select required class="form-control" v-model="ocupationalMedicine.exam_cycles_id">
                  <b-form-select-option v-for="item in list" :key="item.id" :value="item.id">
                    {{ item.name }}
                  </b-form-select-option>
                </select>
              </b-form-group>

              <b-form-group class="col-md-6 px-2" label="Subir archivo" label-for="file">
                <b-form-file required type="file" id="file" ref="file" name="file" browse-text="Buscar"
                  :placeholder="`Selecciona un archivo...`" drop-placeholder="Suelta acá..." v-model="file"
                  @change="uploadFile" v-on:change="uploadFile">
                </b-form-file>
              </b-form-group>

            </div>

            <div class="form-group text-right m-b-0">
              <button type="submit" class="btn btn-primary">
                Guardar
              </button>
              <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                Cancelar
              </button>
            </div>

            <hr />

            <div class="row">
              <div class="col-lg-12">
                <div class="card-body">
                  <div class="row pb-3">
                    <div class="col-12">
                      <form class="form-inline">
                        <div class="form-group mr-2">
                          <label for="productssearch-input" class="sr-only">Buscar</label>
                          <input type="search" class="form-control border-light" id="productssearch-input"
                            placeholder="Buscar..." />
                        </div>
                        <button type="button" class="btn btn-primary mb-2 mb-sm-0">
                          <i class="mdi mdi-search-web"></i>
                        </button>

                      </form>
                    </div>

                  </div>

                  <div class="table-responsive">
                    <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                      <thead>
                        <tr>

                          <th class="text-center align-middle">Empleado/Aprendiz</th>

                          <th class="text-center align-middle">Ciclo del examen</th>
                          <th class="text-center align-middle">Fecha del examen</th>
                          <th class="text-center align-middle">Documento</th>
                          <th class="text-center align-middle">Acciones</th>
                        </tr>
                      </thead>
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr v-for="dato in lista">
                          <td class="text-center align-middle">
                            {{ dato.full_name }}
                          </td>
                          <td class="text-center align-middle">
                            <div v-if="dato.ocupational_medical.length > 0">
                              <div v-if="dato.ocupational_medical[0].exam_cycles_id === 1">
                                <h6>Examen de ingreso
                                </h6>
                              </div>
                              <div v-else-if="dato.ocupational_medical[0].exam_cycles_id === 2">
                                <h6>Exámenes periódicos
                                </h6>
                              </div>
                              <div v-else-if="dato.ocupational_medical[0].exam_cycles_id === 3">
                                <h6>Examen de retiro
                                </h6>
                              </div>

                            </div>
                            <div v-else>
                              <h6>No tiene examen
                              </h6>
                            </div>
                          </td>
                          <td class="text-center align-middle">
                            {{ dato.ocupational_medical.length > 0 ? dato.ocupational_medical[0].exam_date : 'Sin registro'}}
                          </td>
                          <td class="text-center align-middle">
                            <div v-if="dato.ocupational_medical.length > 0 && dato.ocupational_medical[0].file != null">

                              <button style=" background-color: transparent !important; border: none;" type="button"
                                @click="gotoDigitalOcean(`${dato.ocupational_medical[0].file}`)"> <i
                                  class="mdi mdi-cloud-download"></i>
                              </button>

                            </div>
                            <div v-else>
                              <h6>Sin archivo
                              </h6>
                            </div>
                          </td>

                          <td class="text-center align-middle">
                            <div class="col-sm-12">
                              <div v-if="dato.ocupational_medical.length > 0">
                                <b-dropdown variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>

                                  <b-dropdown-item
                                    :to="{ path: `/forms/estandares/${dato.companies_id}/medicina-ocupacional-editar/${dato.ocupational_medical[0].id}` }">Editar</b-dropdown-item>
                                  <b-dropdown-item
                                    v-on:click="deleteMedicine(dato.ocupational_medical[0].id)">Eliminar</b-dropdown-item>
                                  <b-dropdown-item
                                    :to="{ path: `/forms/estandares/medicina-ocupacional-empleados/${dato.id}` }">Ver
                                    registros</b-dropdown-item>
                                  <b-dropdown-item
                                    :to="{ path: `/forms/estandares/${dato.id}/medicina-ocupacional-danger/${dato.ocupational_medical[0].id}` }">Bitacora</b-dropdown-item>


                                </b-dropdown>
                              </div>
                              <div v-else>
                              </div>
                            </div>
                          </td>
                        </tr>


                      </tbody>
                    </table>
                    <div>
                      <Pagination ref="paginator" @fetch="(items) => (lista = items)" />
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>


</template>